import api from '@disco/api/server'
import type { NestedChannelGroup } from 'types/group'
import type { User } from 'types/user'
import { getUserDropdownObject } from '@disco/utils/user'
type MemberVisibilityData = {
  data: {
    groupId: number
    currentUser: User
    parentGroup: NestedChannelGroup
  }
  loadGroup: (...args: Array<any>) => any
}
export const loadManagerAndMemberVisibilityData = async (
  props: MemberVisibilityData,
): Promise<Record<string, any>> => {
  const { data, loadGroup } = props
  const { groupId, currentUser, parentGroup } = data
  const isFolder = parentGroup ? true : false
  const promise = groupId
    ? Promise.all([loadGroup(groupId), api.loadBusinessUsers()])
    : Promise.all([null, api.loadBusinessUsers()])
  const [groupResponse, users] = await promise
  const normalizedUsers = users.map(u => u.user)
  const group = groupResponse ? groupResponse.group : {}
  const { members, managers } = group
  // DISCO staff users should be hidden from visible managers
  let selectedHiddenManagers = []
  let selectedChosenManagers = managers
    ? managers.reduce((accumulator, managerId) => {
        let result = [...accumulator]
        const manager = normalizedUsers.find(user => user.id === managerId)

        if (!manager) {
          selectedHiddenManagers.push(managerId)
        } else {
          const locked = manager.id === currentUser.id
          result.push(getUserDropdownObject(manager, locked))
        }

        return result
      }, [])
    : []
  // DISCO staff users should be hidden from visible members
  let selectedHiddenMembers = members ? [] : selectedHiddenManagers
  let selectedChosenMembers = members
    ? members.reduce((accumulator, memberId) => {
        let result = [...accumulator]
        const member = normalizedUsers.find(user => user.id === memberId)

        if (!member) {
          selectedHiddenMembers.push(memberId)
        } else {
          const userBelongToManagers = managers.includes(memberId)
          result.push(getUserDropdownObject(member, userBelongToManagers))
        }

        return result
      }, [])
    : selectedChosenManagers

  // Add user as manager if managers are empty
  if (!isFolder && selectedChosenManagers.length === 0) {
    selectedChosenManagers = [getUserDropdownObject(currentUser, true)]
  }

  const sortedUsers: User[] = normalizedUsers.sort((a, b) => {
    if (`${a.first_name}${a.last_name}` > `${b.first_name}${b.last_name}`) {
      return 1
    }

    if (`${a.first_name}${a.last_name}` < `${b.first_name}${b.last_name}`) {
      return -1
    }

    return 0
  })
  return {
    businessUsers: sortedUsers,
    businessUsersLoaded: true,
    chosenManagers: selectedChosenManagers,
    hiddenManagers: selectedHiddenManagers,
    chosenMembers: selectedChosenMembers,
    hiddenMembers: selectedHiddenMembers,
    allUsersAreMembers:
      !selectedChosenMembers || selectedChosenMembers.length === 0,
  }
}
